import { Row, Text } from "@/components";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const JobTitleAndCompanyName = ({
  jobTitle,
  companyName,
}: {
  jobTitle: string | null;
  companyName: string | null;
}) => {
  const tooltipText = [jobTitle, companyName].filter(Boolean).join(" · ");

  // Don't render if both pieces are missing
  if (!jobTitle && !companyName) return null;

  return (
    <TooltipProvider delayDuration={500}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Row className="w-fit min-w-0 max-w-full">
            <Text className="truncate text-xs font-medium text-slate-700">
              {jobTitle}
              {jobTitle && companyName && (
                <span className="text-slate-400"> · </span>
              )}
              {companyName}
            </Text>
          </Row>
        </TooltipTrigger>
        <TooltipContent>{tooltipText}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
